// usa.json (~7 MB, ~5 MB minified) is only needed once a ZIP code is typed
// (Sales Simulation, CJ shipping calculator): loaded on demand it becomes its
// own chunk instead of weighing on every page of the main bundle. Nothing may
// import usa.json statically, or webpack puts it back into the main bundle.
let usaZipIndex;
export const loadUsaZipIndex = () => {
    if (!usaZipIndex) {
        usaZipIndex = import("../../usa.json")
            .then(({ default: areas }) => {
                const index = new Map();
                // First entry wins, like the former UsaCity.find().
                areas.forEach(area => { if (!index.has(String(area.zip_code))) index.set(String(area.zip_code), area); });
                return index;
            })
            .catch(error => { usaZipIndex = undefined; throw error; });
    }
    return usaZipIndex;
};

// ZIP area ({ zip_code, state, city... }) or undefined; never throws.
export const findUsaZipArea = (zip) =>
    loadUsaZipIndex().then(index => index.get(String(zip)), () => undefined);
